// src/rds_ui/api/refinementApi.js
//
// Migrated off raw fetch() onto the shared axios instance in
// src/api/client.js (see projectsApi.js in this folder for why). The
// special-cased 409 ("refinement already in progress") behavior is
// preserved.
import { api, getApiError } from "../../api/client";

const BASE = "/rds";

export async function refineArtifact(runId, artifactId, { feedback, cascadeStale = true }) {
  try {
    const res = await api.post(`${BASE}/generations/${runId}/artifacts/${artifactId}/refine`, {
      feedback,
      cascade_stale: cascadeStale,
    });
    return res.data;
  } catch (e) {
    if (e?.response?.status === 409) {
      throw new Error("Refinement already in progress. Please wait.");
    }
    throw new Error(getApiError(e) || "Refinement failed");
  }
}

export async function manualEditArtifact(runId, artifactId, { contentMarkdown, contentJson }) {
  try {
    const res = await api.patch(`${BASE}/generations/${runId}/artifacts/${artifactId}`, {
      content_markdown: contentMarkdown,
      content_json: contentJson,
    });
    return res.data;
  } catch {
    throw new Error("Failed to save edit");
  }
}

export async function fetchArtifactHistory(runId, artifactId) {
  try {
    const res = await api.get(`${BASE}/generations/${runId}/artifacts/${artifactId}/history`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch history");
  }
}

export async function dismissStale(runId, artifactId) {
  try {
    await api.post(`${BASE}/generations/${runId}/artifacts/${artifactId}/dismiss-stale`);
  } catch {
    throw new Error("Failed to dismiss stale warning");
  }
}
